<template>
    <div class="order">
        <h1 class="hero-title has-text-centered">
            Customize your<br/>Gun Mattress
        </h1>

        <div class="page-section">

            <div class="order-box">
                <div class="order-section">
                    <a name="sizes" class="affix-trigger"></a>
                    <h2 class="hero-title has-text-centered">Choose a size</h2>
                    <product-select></product-select>
                </div>
                <div class="order-section color-section">
                    <a name="colors" class="affix-trigger"></a>
                    <h2 class="hero-title has-text-centered">Choose a color</h2>
                    <color-select></color-select>
                </div>
            </div>

            <div class="has-text-centered">
                <button v-if="selectedProduct !== null && selectedColor !== null"
                        class="button btn-success" @click="addToCart()">
                    Add to cart
                </button>
                <button class="button" v-else>
                    Select a
                    <span v-if="selectedProduct === null">size</span>
                    <span v-if="selectedProduct === null && selectedColor === null">and</span>
                    <span v-if="selectedColor === null">color</span>
                </button>
                <div v-if="cartItems.length > 0">
                    <br/>
                    <br/>
                    <div class="cart-listing" style="display: inline-block; max-width: 700px;">
                        <div class="cart-item" v-for="item in cartItems">
                            <div class="cart-control" @click="removeFromCart(item.id)">
                                <icons icon="close"></icons>
                            </div>
                            <div class="cart-description">
                                {{ item.name }} -
                                {{ item.description }}
                            </div>
                            <div class="cart-price">
                                ${{ item.price }}
                            </div>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <router-link tag="button" class="button btn-sm btn-primary" :to="{name: 'review'}">
                        Checkout
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import * as types from "../store/types"
    export default {
        name: 'Order',
        computed: mapGetters(['selectedColor', 'selectedProduct', 'cartItems']),
        methods: {
            addToCart() {
                this.$store.dispatch(types.ADD_TO_CART, {
                    product: this.selectedProduct,
                    color: this.selectedColor.name,
                }).then(data => {
                    this.$emit('openCart')
                })
            },
            removeFromCart(id) {
                this.$store.dispatch(types.REMOVE_FROM_CART, id)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Order.vue?18b9393c